import React from "react";
import { ResponsiveModal } from "@wtc/ui";
import { DetailModalHeaderActions } from "./DetailModalHeaderActions";

interface StatusModalShellProps {
  modalId: string;
  title: string;
  children: React.ReactNode;
}

function StatusModalShell({ modalId, title, children }: StatusModalShellProps) {
  return (
    <ResponsiveModal
      globalModalId={modalId}
      title={title}
      maxWidth="90vw"
      side="bottom"
      headerContent={<DetailModalHeaderActions />}
    >
      <div className="flex items-center justify-center py-12">{children}</div>
    </ResponsiveModal>
  );
}

interface DetailModalLoadingStateProps {
  modalId: string;
  displayName: string;
}

export function DetailModalLoadingState({ modalId, displayName }: DetailModalLoadingStateProps) {
  return (
    <StatusModalShell modalId={modalId} title={`${displayName} Details`}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400">Loading {displayName.toLowerCase()} details...</p>
      </div>
    </StatusModalShell>
  );
}

interface DetailModalErrorStateProps {
  modalId: string;
  displayName: string;
  error: Error;
  refetch: () => void;
}

export function DetailModalErrorState({
  modalId,
  displayName,
  error,
  refetch,
}: DetailModalErrorStateProps) {
  return (
    <StatusModalShell modalId={modalId} title={`${displayName} Details`}>
      <div className="text-center">
        <div className="text-red-600 mb-4">
          <svg
            className="h-12 w-12 mx-auto mb-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h3 className="text-lg font-medium">Error loading details</h3>
        </div>
        <p className="text-gray-600 dark:text-gray-400">{error.message}</p>
        <button type="button"
          onClick={() => refetch()}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Try Again
        </button>
      </div>
    </StatusModalShell>
  );
}
